import { render, staticRenderFns } from "./BoardsRefs.vue?vue&type=template&id=470f1c7a&"
import script from "./BoardsRefs.vue?vue&type=script&lang=js&"
export * from "./BoardsRefs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports